import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { ModalComponent } from '../components/modal/modal.component';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modalSubject = new BehaviorSubject<any>([]);
  modal$ = this.modalSubject.asObservable();
  
  modalSm = {
    panelClass : 'modal-right-sm',
    backdropClass : 'modal-right-sm'
  };
  modalMd = {
    panelClass : 'modal-right-md',
    backdropClass : 'modal-right-md'
  };
  modalLg = {
    panelClass : 'modal-right-lg',
    backdropClass : 'modal-right-lg'
  };
  modalBg = {
    panelClass : 'modal-right-bg',
    backdropClass : 'modal-right-bg'
  };

  modalCentered = {
    panelClass : 'modal-centered',
    backdropClass : 'modal-centered'
  };

  default = {
    autoFocus: false,
    disableCloseOnEscape: true,
    disableClose: true
  };

  componentsModal = {
    'ProfileComponent' : { component : 'ProfileComponent', closeAll:false, options: this.modalSm},
    'MyProfileComponent' : { component : 'MyProfileComponent', closeAll:true, options: this.modalSm},
    'DialogPreferencesComponent' : { component : 'DialogPreferencesComponent', closeAll:true, options: this.modalSm},
    'DialogRequestListComponent' : { component : 'DialogRequestListComponent', closeAll:false, options: this.modalSm},
    'DialogAuthorizationListComponent' : { component : 'DialogAuthorizationListComponent', closeAll:false, options: this.modalSm},
    'IndicateComponent' : { component : 'IndicateComponent',  closeAll:true, options: this.modalSm},
    'RealestateComponent' : { component : 'RealestateComponent',  closeAll:true, options: this.modalSm},
    'FeedbackComponent' : { component : 'FeedbackComponent',  closeAll:true, options: this.modalSm},
    'AuthenticatorComponent' : { component : 'AuthenticatorComponent',  closeAll:true, options: this.modalSm},
    'SignUpComponent' : { component : 'SignUpComponent',  closeAll:true, options: this.modalSm},
    'AdvertiseFormComponent' : { component : 'AdvertiseFormComponent',  closeAll:true, options: this.modalSm},
    'ViewComponentPerson' : { component : 'ViewComponent', options: this.modalMd, data : {type : 'person'}},
    'ViewComponentAd' : { component : 'ViewComponent', options: this.modalBg, data : {type : 'ad'}},
    'TermsComponent' : { component : 'TermsComponent', options: this.modalCentered, closeAll:false },
    'ReasonComponent' : { component : 'ReasonComponent', options: this.modalCentered, closeAll:false },
    'HeatmapComponent' : { component : 'HeatmapComponent', closeAll:true, options: this.modalMd},
    'UnitAmountComponent' : { component : 'UnitAmountComponent', closeAll:true, options: this.modalLg},
    'AvailableComponent' : { component : 'AvailableComponent', closeAll:true, options: this.modalMd},
    'AvailableComponentSmall' : { component : 'AvailableComponent', closeAll:true, options: this.modalSm},
    'SettingsComponent' : { component : 'SettingsComponent', closeAll:true, options: this.modalMd},
    'SharesComponent' : { component : 'SharesComponent',  closeAll:true, options: this.modalSm},
    'RequestsComponent' : { component : 'RequestsComponent',  closeAll:true, options: this.modalSm},
    'FollowersComponent' : { component : 'FollowersComponent',  closeAll:true, options: this.modalSm},
    'ActivitiesComponent' : { component : 'ActivitiesComponent',  closeAll:true, options: this.modalSm},
    'AccessManagerComponent' : { component : 'AccessManagerComponent',  closeAll:true, options: this.modalSm},
    'UsersManagerComponent' : { component : 'UsersManagerComponent',  closeAll:true, options: this.modalSm},
    'PostsComponent' : { component : 'PostsComponent',  closeAll:false, options: this.modalCentered},
    'GalleryComponent' : { component : 'GalleryComponent',  closeAll:false, options: this.modalSm},
    'CanvaComponent' : { component : 'CanvaComponent',  closeAll:true, options: this.modalCentered},
    'PersonComponent' : { component : 'PersonComponent',  closeAll:true, options: this.modalMd},
  };

  private control:any = [];

  constructor(protected dialog: MatDialog) { }

  async openModal(param){
    //console.log('MODAL', param, this.componentsModal[param.component]);
    if(typeof this.componentsModal[param.component] =='undefined')
      return;
    
    if(this.componentsModal[param.component]?.closeAll == true && !param?.params?.notClose){
      this.dialog.closeAll();
      await new Promise( resolve => setTimeout(resolve, 200));
    }

    let modalId = param.component+'-'+Math.random();
      
    let settings = {id:modalId, ...this.default, ...this.componentsModal[param.component]?.options || {}, data: {...param.params, modalId:modalId, component: this.componentsModal[param.component].component, ... this.componentsModal[param.component]?.data || {}}};
    
    let modal = this.dialog.getDialogById(modalId);

    if(!modal){
      let dialog = this.dialog.open(ModalComponent, settings);

      dialog.backdropClick().subscribe(result => {
        this.safeClose(dialog);
      });

      dialog.keydownEvents().subscribe(result => {
        if(result?.key == 'Escape')
          this.safeClose(dialog);
      });
      
    } else {
      modal.afterClosed().subscribe(result => {
        this.dialog.open(ModalComponent, settings);
      });
      modal.close();
      this.cleanClass();
    }
  }

  safeClose(modal){
    if(!!$('.pswp.pswp--open')?.length)
      return;

    modal.close();
    this.cleanClass();
  }

  closeAll(){
    this.dialog.closeAll();
    this.cleanClass();
  }

  cleanClass(){
    if(!$('.cdk-global-overlay-wrapper').length)
      $('body.modal-open').removeClass('modal-open');
  }

}



@Injectable({
  providedIn: 'root'
})
export class CanActivateModalGuard implements CanActivate {

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    return false;
  }
}